<template>
    <div>
        <div class="card-body p-0">
            
        <table class="table table-hover">
            <thead>
            <tr>
                <th>Name</th>
                <th>User</th>
                <th>Status</th>
                <th class="text-center">Action</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="api_key in api_keys" :key="api_key.id" v-animate-css="'slideInLeft'">
                    <td>{{ api_key.name }}</td>
                    <td>{{ user.first_name }} {{ user.last_name }}</td>
                    <td>
                    <span class="alert alert-success btn-xs" :class="{
                        'alert-success': api_key.status == 'active',
                        'alert-warning': api_key.status == 'pending',
                        'alert-danger': api_key.status == 'suspended'}"> {{ api_key.status | capitalize }} 
                    </span>
                    </td>
                    <td class="text-center">
                    <div class="btn-group">
                        <router-link :to="{name: 'api_keys', params: {'id': api_key.id} }" class="btn btn-default btn-sm">
                        <i class="fa fa-edit"></i> Edit</router-link>
                    </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from '@/services/repositories/ManagementAPI/RepositoryFactory' 
const APIRepo = RepositoryFactory.get('local_apis')

export default {
    name: 'User API Keys',
    props: {
        user: {
            type: Object,
            default: () => ({})
        },
        profile: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            errors: [],
            messages: [],
            api_keys: []
        }
    },
    mounted(){
      this.loadAPIKeys()
    },
    created() {
    },

    methods: {
        loadAPIKeys: function() {
            APIRepo.filter({user: this.user.id}).then(result => {
                this.totalRecords = result.data.count
                this.api_keys = result.data.results
            }).catch(err => {})
        },
    }
}
</script>